"use client";

import * as React from "react";
import { ThemeProvider as NextThemesProvider } from "next-themes";
import StoreProvider from "@/lib/redux-toolkit/StoreProvider";
import Loading from "@/components/loading";

export function ThemeProvider({
  children,
  ...props
}: React.ComponentProps<typeof NextThemesProvider>) {
  return (
    <NextThemesProvider {...props}>
      <StoreProvider>
        <Loading />
        {children}
      </StoreProvider>
    </NextThemesProvider>
  );
}
